import FooterLink from '@/components/FooterLink';

export default function Footer() {
  return (
    <div className="bg-white w-full py-8 px-4 sm:px-8 lg:px-32 xl:px-44 flex flex-col justify-center items-center gap-8">
      <div className="w-full max-w-5xl flex flex-col lg:flex-row justify-between items-start gap-6 lg:gap-8">
        <div className="flex flex-col justify-start items-start gap-2 w-full lg:w-1/3">
          <FooterLink title="Legal" variant="sectionTitle" />
          <nav aria-label="Legal" className="mt-2 flex flex-col gap-2">
            <FooterLink title="Terms of Service" href="/terms-of-service" target="_blank" />
            <FooterLink title="Privacy Policy" href="/privacy-policy" target="_blank" />
          </nav>
        </div>

        <div className="flex flex-col justify-start items-start gap-2 w-full lg:w-1/3">
          <FooterLink title="Support" variant="sectionTitle" />
          <nav aria-label="Support" className="mt-2 flex flex-col gap-2">
            <FooterLink title="Contact Us" />
            <FooterLink title="support@equipool.us" />
            <FooterLink title="+1 8003473047" />
            <span className="text-xs text-gray-400 mt-1">Operation Hours: 8AM - 5PM PST</span>
          </nav>
        </div>

        <div className="flex flex-col justify-start items-start gap-2 w-full lg:w-1/3">
          <FooterLink title="Agents" variant="sectionTitle" />
          <nav aria-label="Support" className="mt-2 flex flex-col gap-2">
            <FooterLink title="Authorized Agents" href="/authorized-agents" target="_blank" />
          </nav>
        </div>

        <div className="flex flex-col justify-start items-start gap-2 w-full lg:w-1/3">
          <FooterLink title="Socials" variant="sectionTitle" />
          <div className="mt-2 flex gap-3">
            <img src="/mdi-instagram.svg" alt="Instagram" className="w-6 h-6" />
            <img src="/ic-baseline-facebook.svg" alt="Facebook" className="w-6 h-6" />
            <img src="/mdi-linkedin.svg" alt="LinkedIn" className="w-6 h-6" />
          </div>
        </div>
      </div>
      <div className="w-full max-w-5xl text-gray-600 text-xs font-normal leading-relaxed text-center lg:text-left">
        <FooterLink title="Security & Legal" variant="sectionTitle" />
        <p>
          Equipool is a private lending marketplace connecting borrowers and investors. Payments and escrow services are
          provided by trusted third-party financial service providers. All user data is handled securely using
          industry-standard safeguards and in compliance with applicable data protection and privacy laws. All lending
          arrangements are governed by legally binding agreements between the participating parties.
        </p>
        <p className="mt-3">
          Investments made through Equipool are not guaranteed and are not protected by any government insurance scheme.
          Private lending involves risk, including the potential loss of capital.
        </p>
        <p className="mt-4 text-gray-500">© 2026 Equipool. All rights reserved.</p>
      </div>
    </div>
  );
}
